import { ENTITIES } from 'src/models/QuerybuilderModel';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import UnselectAllMenubutton from 'src/components/Control/Buttons/UnselectAllMenuButton';
import SelectAllMenubutton from 'src/components/Control/Buttons/SelectAllMenuButton';
import ConfigureColumnsButton from 'src/components/Control/Buttons/ConfigureColumnsButton';
import AddEventButton from 'src/components/Control/Buttons/AddEventButton';
import EditFundraisingButton from 'src/components/Control/Buttons/EditEventButton';
import DeleteFundraisingButton from 'src/components/Control/Buttons/DeleteFundraisingButton';

const EventToolbar = () => {
  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.fundraisings] || [],
  );

  return (
    <>
      <AddEventButton />
      <EditFundraisingButton
        disabled={selections.length !== 1} />
      <DeleteFundraisingButton
        disabled={!selections.length} />
      <ConfigureColumnsButton
        entity={ENTITIES.fundraisings} />
      <UnselectAllMenubutton
        entity={ENTITIES.fundraisings}
        disabled={!selections.length} />
      <SelectAllMenubutton
        entity={ENTITIES.fundraisings} />
    </>
  );
};
export default EventToolbar;
//
